import makeStyles from '@mui/styles/makeStyles'

const cardShape = 'polygon(0% 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    padding: spacing(0, 3, 3)
  },
  accordionRoot: {
    paddingRight: spacing(2)
  },
  accordion: {
    '&:before': {
      display: 'none'
    }
  },
  accordionExapanded: {
  },
  summary: {
    padding: 0,
    height: 72,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  detail: {
    padding: spacing(1.5, 0, 0),
    flexDirection: 'column'
  },
  heading: {
    fontSize: 20,
    color: palette.text.secondary
  },
  headingActive: {
    color: palette.text.primary
  },
  homePageBannerCtn: {
    maxHeight: 220,
    backgroundColor: ({ bg }) => bg
  },
  homePageBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  homePageBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  homePageBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  homePageBannerImg: {
    width: '100%',
    height: 220
  },
  exploreMenuBannerCtn: {
    width: 770,
    height: 250,
    backgroundColor: ({ bg }) => bg
  },
  exploreMenuBannerCard: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0,
    width: 770,
    height: 250,
    backgroundColor: ({ bg }) => bg
  },
  exploreMenuBannerEdge: {
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    width: 770,
    height: 250,
    backgroundColor: ({ bg }) => bg
  },
  exploreMenuImgCtn: {
    width: 250
  },
  exploreMenuBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  exploreMenuBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  exploreMenuBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  exploreMenuBannerImg: {
    width: 250,
    height: 250
  },
  verticalBannerCtn: {
    width: 280,
    minHeight: 250,
    backgroundColor: ({ bg }) => bg
  },
  verticalBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  verticalBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  verticalBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  verticalBannerImg: {
    width: '100%',
    height: 280
  },
  verticalBannerCard: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0,
    width: 280,
    backgroundColor: ({ bg }) => bg
  },
  verticalBannerEdge: {
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    width: 280,
    backgroundColor: ({ bg }) => bg
  },
  articleHorizontalBannerCtn: {
    width: 670,
    height: 290,
    backgroundColor: ({ bg }) => bg
  },
  articleHorizontalBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  articleHorizontalBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  articleHorizontalBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  articleHorizontalBannerImg: {
    width: 290,
    height: 290
  },
  articleHorizontalBannerCard: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0,
    width: 670,
    height: 290,
    backgroundColor: ({ bg }) => bg
  },
  articleHorizontalBannerEdge: {
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    width: 670,
    height: 290,
    backgroundColor: ({ bg }) => bg
  },
  bannerBtn: {
    backgroundColor: ({ btn }) => btn,
    border: 'none',
    color: ({ btnText }) => btnText,
    '&:hover': {
      filter: 'brightness(.98)',
      backgroundColor: ({ btn }) => btn
    }
  }
}))
